const settings: ClientSettings = {
  name: "PaGoal",
  benefitCardName: "Cartão Benefício",
  theme: {
    token: {
      colorPrimary: "#051F3D",
      colorHighlight: "#529EF8",
    },
    components: {
      // O padrão do antd some sobre o card escuro dos steps.
      Button: {
        colorBgContainerDisabled: "#E6E9ED",
        colorTextDisabled: "#8A92A6",
        borderColorDisabled: "#D9DDE3",
      },
    },
  },
  assets: {
    background: "/pagoal-login-bg.png",
    logo: "/pagoal-logo-dark.svg",
    logo_header: "/pagoal-logo.svg",
    favicon: "/pagoal-favicon.svg",
    card: "/pagoal-card.png",
    consignedCard: "/pagoal-card.png",
  },
};

export default settings;
